import axios from 'axios';
// import { getToken } from './auth';

//export const baseURL = 'http://localhost:3333/';
export const baseURL = 'https://api.jumbatec.com/';
const api = axios.create({
  baseURL: baseURL,
  rejectUnauthorized: false,
});

export default api;
